import { FlexColumn, LabeledInput, MaterialIcon } from '@gorila-shared-ui/components';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  user?: string | number;
  password?: string | number;
  code?: string | number;
  codeSend?: boolean;
  onChangeUser?: (value: string) => void;
  onChangePass?: (value: string) => void;
  onChangeCode?: (value: string) => void;
};

export function ForgottenPasswordForm({
  onChangeUser,
  onChangePass,
  onChangeCode,
  user,
  password,
  code,
  codeSend = false,
}: Readonly<Props>) {
  const { css, theme } = useStyles();

  return (
    <FlexColumn
      centered
      gap={theme.sizing.scale600}
      classNames={css({ paddingTop: theme.sizing.scale600 })}
    >
      {codeSend ? (
        <LabeledInput
          placeholder={'Codigo'}
          value={code}
          onChange={onChangeCode}
          size={'default'}
          startEnhancer={<MaterialIcon name="more_horiz" />}
        />
      ) : (
        <LabeledInput
          placeholder={'Usuario'}
          value={user}
          onChange={onChangeUser}
          size={'default'}
          startEnhancer={<MaterialIcon name="account_circle" />}
        />
      )}
      {code && (
        <LabeledInput
          placeholder={'Contraseña'}
          value={password}
          onChange={onChangePass}
          type="password"
          size={'default'}
          startEnhancer={<MaterialIcon name="lock" />}
        />
      )}
    </FlexColumn>
  );
}
